import { useLoaderData } from "react-router-dom";
import { doFetch } from "../../utils/doFetch";
import { AvailabilityAdministration } from "./AvailabilityAdministration";
import { IDOAShiftsData } from "./AvailabilityAdministrationData";

export const availabilityAdministrationRouteLoader = async ({ request, params }: { request: any, params: any }) =>
  doFetch(
    `doa/shifts`,
    { signal: request.signal },
    true,
    true,
    {},
  )

export const AvailabilityAdministrationRoute = () => {
  const data = useLoaderData() as IDOAShiftsData;
  return (
    <AvailabilityAdministration shifts={data.shifts} />
  )
}